import React, { useState } from 'react';

function QuickRebookBar({ onSignIn, onContinueAsGuest, onDismiss }) {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem('welcomeBannerDismissed') === 'true';
    } catch {
      return false;
    }
  });

  function persistDismiss() {
    try { sessionStorage.setItem('welcomeBannerDismissed', 'true'); } catch {}
    setDismissed(true);
  }

  if (dismissed) return null;

  return (
    <div className="quick-rebook-bar">
      <div className="quick-rebook-content">
        <p className="quick-rebook-text">Welcome back! Sign in for faster booking</p>
        <div className="quick-rebook-buttons">
          <button className="quick-rebook-btn signin" onClick={() => {
            persistDismiss();
            onSignIn();
          }}>
            SIGN IN
          </button>
          <button className="quick-rebook-btn guest" onClick={() => {
            persistDismiss();
            onContinueAsGuest();
          }}>
            CONTINUE AS GUEST
          </button>
        </div>
      </div>
      <button className="quick-rebook-close" onClick={() => {
        persistDismiss();
        onDismiss();
      }}>✕</button>
    </div>
  );
}

export default QuickRebookBar;
